import React, { useState, useEffect } from 'react';
import StockIssue from '../components/StockIssue';
import StockReceive from '../components/StockReceive';
import StockAdjust from '../components/StockAdjust';
import StockReserve from '../components/StockReserve';
import StockRelease from '../components/StockRelease';
import StockList from '../components/StockList';
import Modal from '../components/Modal';
import { useNavigate } from 'react-router-dom';
import QrScan from '../components/QrScan';
import QrGenerator from './QrGenerator';
import ScanHistory from '../components/ScanHistoryList';
// import GpsTracker from '../components/GpsTracker';
import LowStockList from '../components/LowStockList';
import MultiQrPdf from '../components/MultiQrPdf';
import { hasRole } from '../utils/auth';

const StockPage: React.FC = () => {

    const navigate = useNavigate();

    useEffect(() => {
        if (!hasRole(['super_admin', 'staff', 'technician'])) {
            navigate('/');
        }
    }, [navigate]);

    const [modal, setModal] = useState<null | 'lowstock' | 'qrscan' | 'qrgenerator' | 'multiqrpdf' | 'scanhistory' | 'reserve' | 'release' | 'receive' | 'issue' | 'adjust'>(null);

    // 侧边栏展开/收起状态
    const [isNavOpen, setIsNavOpen] = useState<boolean>(false);

    return (
        <div className="container mx-auto p-1 pb-14">
            {/* <button
                onClick={() => navigate(-1)}
                className="z-50 flex items-center gap-1 text-xs md:text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 px-3 py-1.5 rounded mb-3 transition-colors"
            >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back
            </button> */}

            {/* 可抽屉式自动隐藏的侧边栏 */}
            <div
                id="quick-nav-bar"
                className={`text-xs md:text-sm stock-navgrid fixed top-16 left-0 grid grid-cols-1 gap-6 p-2 pb-36 border-r-2 border-gray-200 bg-white shadow-xl z-30 
                transition-transform duration-300 ease-in-out h-auto max-h-[calc(100vh-4rem)]
                ${isNavOpen ? 'translate-x-0' : '-translate-x-full'}
                [&::-webkit-scrollbar]:w-2 
                [&::-webkit-scrollbar-track]:bg-slate-100 
                [&::-webkit-scrollbar-thumb]:bg-slate-400 
                [&::-webkit-scrollbar-thumb]:rounded-full`}
            >
                {/* 悬浮在侧边栏右侧边缘的触发/收起按钮 */}
                <button
                    onClick={() => setIsNavOpen(!isNavOpen)}
                    className="absolute -right-7 top-10 bg-teal-600 text-white p-1.5 rounded-r-md shadow-md hover:bg-teal-700 focus:outline-none flex items-center justify-center cursor-pointer"
                    title={isNavOpen ? "收起导航" : "展开导航"}
                >
                    <svg
                        className={`w-4 h-4 transition-transform duration-300 ${isNavOpen ? 'rotate-180' : 'rotate-0'}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                    </svg>
                </button>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">Stock List</h2>
                    <button
                        onClick={() => { navigate('/stock-management'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm mb-1 px-2 py-1 bg-teal-600 text-white rounded hover:bg-teal-700 w-full"
                    >
                        Go to
                    </button>
                </div>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">Low Stock</h2>
                    <button
                        onClick={() => { setModal('lowstock'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm mb-1 px-2 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700 w-full"
                    >
                        Open
                    </button>
                </div>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">QR Scan</h2>
                    <button
                        onClick={() => { setModal('qrscan'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm px-2 py-1 bg-purple-600 text-white rounded hover:bg-purple-700 w-full"
                    >
                        Open
                    </button>
                </div>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">QR Generate</h2>
                    <button
                        onClick={() => { setModal('qrgenerator'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm mb-1 px-2 py-1 bg-slate-600 text-white rounded hover:bg-slate-700 w-full"
                    >
                        Open
                    </button>
                </div>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">Multi QR PDF</h2>
                    <button
                        onClick={() => { setModal('multiqrpdf'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm mb-1 px-2 py-1 bg-slate-400 text-white rounded hover:bg-slate-500 w-full"
                    >
                        Open
                    </button>
                </div>

                <div className="md:col-span-1 flex flex-col items-center">
                    <h2 className="text-xs mb-1 text-center font-semibold">Scan History</h2>
                    <button
                        onClick={() => { setModal('scanhistory'); setIsNavOpen(false); }}
                        className="text-xs md:text-sm mb-1 px-2 py-1 bg-amber-600 text-white rounded hover:bg-amber-700 w-full"
                    >
                        Open
                    </button>
                </div>
            </div>

            {/* 遮罩层：展开时点击屏幕空白处自动收起 */}
            {isNavOpen && (
                <div
                    onClick={() => setIsNavOpen(false)}
                    className="fixed inset-0 bg-black/20 z-20"
                />
            )}

            {/* 主内容区域：边距微调 */}
            <div className="w-auto max-w-xl md:max-w-7xl mx-auto ml-8 md:ml-12 md:mr-8 mb-4">
                <StockList />
            </div>

            <div className="stock-modal-container">
                <Modal isOpen={modal === 'lowstock'} onClose={() => setModal(null)} title="Low Stock Item List">
                    <LowStockList />
                </Modal>
                <Modal isOpen={modal === 'qrscan'} onClose={() => setModal(null)} title="QR Scanner">
                    <QrScan />
                </Modal>
                <Modal isOpen={modal === 'qrgenerator'} onClose={() => setModal(null)} title="QR Generator">
                    <QrGenerator />
                </Modal>
                <Modal isOpen={modal === 'multiqrpdf'} onClose={() => setModal(null)} title="Multi QR PDF">
                    <MultiQrPdf />
                </Modal>
                <Modal isOpen={modal === 'scanhistory'} onClose={() => setModal(null)} title="Scan History">
                    <ScanHistory />
                </Modal>
                <Modal isOpen={modal === 'reserve'} onClose={() => setModal(null)} title="Stock Reserve">
                    <StockReserve />
                </Modal>
                <Modal isOpen={modal === 'release'} onClose={() => setModal(null)} title="Stock Release">
                    <StockRelease />
                </Modal>
                <Modal isOpen={modal === 'receive'} onClose={() => setModal(null)} title="Stock Receive">
                    <StockReceive />
                </Modal>
                <Modal isOpen={modal === 'issue'} onClose={() => setModal(null)} title="Stock Issue">
                    <StockIssue />
                </Modal>
                <Modal isOpen={modal === 'adjust'} onClose={() => setModal(null)} title="Stock Adjustment">
                    <StockAdjust />
                </Modal>
            </div>

        </div>
    );
};

export default StockPage;